import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { Product, ProductCellBalance, ProductInWarehouse } from 'src/typings';
import { CatalogStockDialogComponent } from '../catalog-stock-dialog/catalog-stock-dialog.component';

@Component({
  selector: 'app-stock-table',
  templateUrl: './stock-table.component.html',
  styleUrls: ['./stock-table.component.scss']
})
export class StockTableComponent {
  constructor(private dialog: MatDialog) {}

  private _product: Product | undefined;

  @Input() set product(value: Product | undefined) {
    if (!value) return;
    this._product = value;
    this.stock = value.stock;
  }

  get product() {
    return this._product;
  }

  columnsToDisplay = ['warehouse', 'quan', 'cell', 'menu'];

  stock: ProductInWarehouse[] = [];

  getBalances(row: ProductInWarehouse): ProductCellBalance[] {
    return (this.product?.cellBalances || []).filter(
      (balance) => Number(balance.warehouseId) === Number(row.warehouse.id)
    );
  }

  updateTable(list: ProductInWarehouse[]) {
    this.stock = [];
    this.stock = list;
  }

  edit(row: ProductInWarehouse) {
    if (!this.product?.id || !row.warehouse?.id) return;
    const productId = this.product.id;
    const dialogRef = this.dialog.open(CatalogStockDialogComponent, {
      width: '720px',
      maxWidth: '95vw',
      autoFocus: false,
      restoreFocus: true
    });
    dialogRef.componentInstance.product = this.product;
    dialogRef.componentInstance.warehouse = row.warehouse;
    dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      // The dialog refreshes the shared product, including after stock operations.
      if (this.product?.id === productId) {
        this.updateTable([...(this.product.stock || [])]);
      }
    });
  }
}
